export class BillingData {
    userId:number;
    firstName: string;
    lastName: string;
    email:string;

    planId: string;
    planName:string;
    planPeriodType:string;
    planPeriodLength:number;

    baseAmount: number;
    couponId: number;
    couponCode: string;
    discountAmount: number;
    netAmount: number;


    address: string;
    city: string;
    state: string;
    country: string;
    zip: string;
    phone: string;


    cardNumber: string;
    cardName: string;
    cardExp: string;
    cardCvv: string;

}